/**
 * Formatação HTML para itens do SelectSuggestion / vs-select (innerHTML).
 * Genérico: duas linhas (destaque + secundária menor); separador opcional antes do &lt;br/&gt;.
 */

/**
 * @param {unknown} s
 * @returns {string}
 */
export function escapeHtml(s) {
  if (s == null || s === '') return ''
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * @param {object|null|undefined} model
 * @param {string | string[] | ((m: object) => string)} spec
 * @returns {string}
 */
function resolveLine(model, spec) {
  if (model == null || spec == null) return ''
  if (typeof spec === 'function') return String(spec(model) ?? '').trim()
  if (typeof spec === 'string') return String(model[spec] ?? '').trim()
  if (Array.isArray(spec)) {
    for (let i = 0; i < spec.length; i++) {
      const key = spec[i]
      const v = model[key]
      if (v != null && String(v).trim() !== '') return String(v).trim()
    }
    return ''
  }
  return ''
}

/**
 * Duas linhas (primária + secundária com classes Bootstrap/Vuexy). Opcionalmente `separator`
 * antes do &lt;br/&gt; (ex.: um espaço) se o texto fechado do select colar demais.
 *
 * @param {object|null|undefined} model
 * @param {{
 *   primary: string | string[] | ((m: object) => string)
 *   secondary: string | string[] | ((m: object) => string)
 *   separator?: string
 *   secondaryClass?: string
 *   fallback?: string | string[] | ((m: object) => string)
 * }} options
 * @returns {string}
 *
 * @example
 * // Usuário (nome + e-mail)
 * formatSuggestionTwoLinesHtml(m, { primary: 'name', secondary: 'email' })
 *
 * @example
 * // Pessoa jurídica
 * formatSuggestionTwoLinesHtml(m, {
 *   primary: ['company_name', 'trading_name'],
 *   secondary: 'cnpj',
 *   secondaryClass: 'text-sm text-muted suggestion-secondary-line',
 * })
 *
 * @example
 * // Cupom
 * formatSuggestionTwoLinesHtml(m, {
 *   primary: 'name',
 *   secondary: 'code',
 * })
 */
export function formatSuggestionTwoLinesHtml(model, options = {}) {
  if (!model) return ''
  const {
    primary,
    secondary,
    separator = ' ',
    secondaryClass = 'text-sm text-muted suggestion-secondary-line',
    fallback = ['id']
  } = options

  const line1 = resolveLine(model, primary)
  const line2 = resolveLine(model, secondary)

  if (line1 && line2) {
    return `${escapeHtml(line1)}${separator}<br/><div class="${secondaryClass}">${escapeHtml(line2)}</div>`
  }

  const single = line1 || line2
  if (single) return escapeHtml(single)

  const fb = resolveLine(model, fallback)
  return escapeHtml(fb || '')
}

/**
 * Atalho: usuário com nome + e-mail (mesmo contrato de antes).
 * @param {object|null|undefined} model
 * @returns {string}
 */
export function formatUserNameEmailHtml(model) {
  return formatSuggestionTwoLinesHtml(model, {
    primary: 'name',
    secondary: 'email'
  })
}
